module.exports = __webpack_public_path__ + "img/lx100.705932c3.webp";